import { getOrCreateCommentManager } from 'Guide/FrameModules/comments';
import { SettingsCookie } from 'Shared/utils/settings-cookie';
import { useState } from 'react';

function openStepComments(stepContainer: HTMLElement) {
   const expandingContainer = stepContainer.querySelector('.comments-container') as HTMLElement;
   const manager = getCommentManager(stepContainer);

   if (!expandingContainer) {
      return;
   }

   void manager.loadComments().then(() => {
      expandingContainer.style.height = 'auto';
      expandingContainer.style.opacity = '1';
      expandingContainer.classList.remove('closed');
   });
}

function closeStepComments(stepContainer: HTMLElement) {
   const expandingContainer = stepContainer.querySelector('.comments-container') as HTMLElement;

   if (!expandingContainer) {
      return;
   }

   expandingContainer.classList.add('closed');
   expandingContainer.style.height = '0';
   expandingContainer.style.opacity = '0';
}

function getCommentManager(stepContainer: HTMLElement) {
   const commentContainer = stepContainer.querySelector('.js-comment-container') as HTMLElement;
   return getOrCreateCommentManager(commentContainer);
}

function getAllStepsWithComments() {
   const steps = Array.from(document.querySelectorAll('.js-step')) as HTMLElement[];
   const stepWithComments = steps.filter((item: HTMLElement) => {
      const commentEl = item.querySelector('button.js-comment-count');
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      const numComments = Number(commentEl.attributes.getNamedItem('data-numcomments').value);
      return numComments > 0;
   });
   return stepWithComments;
}

function expandAllComments() {
   SettingsCookie.set('expand-comments', 'true');
   getAllStepsWithComments().forEach(openStepComments);
}

function collapseAllComments() {
   SettingsCookie.set('expand-comments', 'false');
   getAllStepsWithComments().forEach(closeStepComments);
}

function useExpandCollapseComments(): [boolean, () => void] {
   const [isExpanded, setExpandComments] = useState(
      SettingsCookie.get('expand-comments') === 'true'
   );

   function toggleExpandComments() {
      if (isExpanded) {
         collapseAllComments();
      } else {
         expandAllComments();
      }
      setExpandComments(!isExpanded);
   }

   return [isExpanded, toggleExpandComments];
}

export { useExpandCollapseComments };
